(function(){
    'use strict';
    angular.module('Services').service('TransitWarrantyAdditionalCoverageTableService', TransitWarrantyAdditionalCoverageTableService);
    TransitWarrantyAdditionalCoverageTableService.$inject = [
        'TableLiteFactory'
    ];

    function TransitWarrantyAdditionalCoverageTableService(
        TableLiteFactory
    ) {
        return function(reportData) {
            const tableStructure = {
                tableName: 'TransitWarrantyAdditionalCoverageTableService',
                config: {
                    noPagination: true,
                    noFooter: true
                },
                headers: [
                    {
                        label: 'Created Date',
                        viewName: 'createdDate'
                    },
                    {
                        label: 'Reference Number',
                        viewName: 'referenceNumber'
                    },
                    {
                        label: 'Consignment Number',
                        viewName: 'consignmentNumber'
                    },
                    {
                        label: 'Carrier Profile',
                        viewName: 'carrierProfileName'
                    },
                    {
                        label: 'Customer Name',
                        viewName: 'customerName'
                    },
                    {
                        label: 'Declared Value',
                        viewName: 'declaredValue'
                    },
                    {
                        label: 'Free Coverage',
                        viewName: 'freeCoverage'
                    },
                    {
                        label: 'Additional Coverage',
                        viewName: 'additionalCoverage'
                    },
                    {
                        label: 'Total Coverage',
                        viewName: 'totalCoverage'
                    },
                    {
                        label: 'Amount Paid',
                        viewName: 'amountPaid'
                    }
                ],
                data: []
            };

            const tableActions = new TableLiteFactory(tableStructure, {
                serviceCallback: function(callback) {
                    callback({content: reportData})
                },
                callbackFormat: ['success', 'error', 'filter'],
                postRequestCallback: data => {
                    buildTableData(data);
                },
                postRequestErrorCallback: data => {
                    buildTableData(null);
                }
            });

            function buildTableData(data) {
                if (!data) {
                    return tableStructure;
                }

                tableActions.initializeTableData(data);
                angular.forEach(data.content, row => {
                    tableStructure.data.push(row);
                });
            }

            function updateTableData(reportData) {
                tableStructure.data = [];
                buildTableData({content: reportData});
            }

            function toggleLoadingIndicator(isLoading) {
                tableStructure.isFetching = isLoading;
            }

            this.toggleLoadingIndicator = toggleLoadingIndicator;
            this.updateTableData = updateTableData;
            this.tableData = tableStructure;
        }
    }
})();



// WEBPACK FOOTER //
// ./js/services/tables/transit-warranty/TransitWarrantyAdditionalCoverageTableService.js